export default __webpack_public_path__ + "static/media/running.0e2c5fee.jpg";